"use client";

import { c as _c } from "react/compiler-runtime";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import { numberWithCommas } from "@/helpers/Helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { INotificationAllDrops } from "@/types/feed.types";
import { getNotificationVoteColor } from "../drop-reacted/NotificationDropReacted";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import NotificationDrop from "../subcomponents/NotificationDrop";
import NotificationHeader from "../subcomponents/NotificationHeader";
import NotificationTimestamp from "../subcomponents/NotificationTimestamp";
import { getIsDirectMessage, useWaveNavigation } from "../utils/navigationUtils";
export default function NotificationAllDrops(t0) {
  const $ = _c(46);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const {
    createReplyClickHandler,
    createQuoteClickHandler
  } = useWaveNavigation();
  const drop = notification.related_drops?.[0];
  if (!drop) {
    return null;
  }
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== activeDrop || $[1] !== createQuoteClickHandler || $[2] !== createReplyClickHandler || $[3] !== drop || $[4] !== notification.additional_context.vote || $[5] !== notification.created_at || $[6] !== notification.related_identity || $[7] !== onQuote || $[8] !== onReply) {
    const isDirectMessage = getIsDirectMessage(drop.wave);
    let t9;
    if ($[18] !== notification.additional_context.vote) {
      t9 = () => {
        if (typeof notification.additional_context.vote === "number") {
          const isReset = notification.additional_context.vote === 0;
          if (isReset) {
            return <span className="tw-text-iron-400">reset rating to 0</span>;
          }
          return <><span className="tw-text-iron-400">rated</span><span className={`${getNotificationVoteColor(notification.additional_context.vote)} tw-pl-1 tw-font-medium`}>{notification.additional_context.vote > 0 && "+"}{numberWithCommas(notification.additional_context.vote)}</span></>;
        }
        return <span className="tw-text-iron-400">posted</span>;
      };
      $[18] = notification.additional_context.vote;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    const getContent = t9;
    t7 = "tw-w-full tw-flex tw-flex-col tw-space-y-2";
    const t10 = notification.related_identity;
    let t11;
    if ($[20] !== notification.related_identity) {
      t11 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
      $[20] = notification.related_identity;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== getContent) {
      t12 = getContent();
      $[22] = getContent;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    let t13;
    if ($[24] !== notification.created_at) {
      t13 = <NotificationTimestamp createdAt={notification.created_at} />;
      $[24] = notification.created_at;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    let t14;
    if ($[26] !== t12 || $[27] !== t13) {
      t14 = <span className="tw-text-sm tw-font-normal tw-text-iron-50">{t12}{" "}{t13}</span>;
      $[26] = t12;
      $[27] = t13;
      $[28] = t14;
    } else {
      t14 = $[28];
    }
    if ($[29] !== notification.related_identity || $[30] !== t11 || $[31] !== t14) {
      t8 = <NotificationHeader author={t10} actions={t11}>{t14}</NotificationHeader>;
      $[29] = notification.related_identity;
      $[30] = t11;
      $[31] = t14;
      $[32] = t8;
    } else {
      t8 = $[32];
    }
    T0 = NotificationDrop;
    t1 = drop;
    t2 = activeDrop;
    t3 = onReply;
    t4 = onQuote;
    t5 = createReplyClickHandler(drop.wave.id, isDirectMessage);
    t6 = createQuoteClickHandler(isDirectMessage);
    $[0] = activeDrop;
    $[1] = createQuoteClickHandler;
    $[2] = createReplyClickHandler;
    $[3] = drop;
    $[4] = notification.additional_context.vote;
    $[5] = notification.created_at;
    $[6] = notification.related_identity;
    $[7] = onQuote;
    $[8] = onReply;
    $[9] = T0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    T0 = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
  }
  let t9;
  if ($[33] !== T0 || $[34] !== onDropContentClick || $[35] !== t1 || $[36] !== t2 || $[37] !== t3 || $[38] !== t4 || $[39] !== t5 || $[40] !== t6) {
    t9 = <T0 drop={t1} activeDrop={t2} onReply={t3} onQuote={t4} onReplyClick={t5} onQuoteClick={t6} onDropContentClick={onDropContentClick} />;
    $[33] = T0;
    $[34] = onDropContentClick;
    $[35] = t1;
    $[36] = t2;
    $[37] = t3;
    $[38] = t4;
    $[39] = t5;
    $[40] = t6;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  let t10;
  if ($[42] !== t7 || $[43] !== t8 || $[44] !== t9) {
    t10 = <div className={t7}>{t8}{t9}</div>;
    $[42] = t7;
    $[43] = t8;
    $[44] = t9;
    $[45] = t10;
  } else {
    t10 = $[45];
  }
  return t10;
}